import { createFileRoute } from "@tanstack/react-router";
import { PaymentsPage } from "@/app/connect/pages/payments";

type PaymentsSearchParams = {
	provider_id?: string;
};

function cleanId(value: unknown): string | undefined {
	if (typeof value === "number") return String(value);
	if (typeof value === "string") {
		const cleaned = value.replace(/^["']|["']$/g, "");
		return cleaned || undefined;
	}
	return undefined;
}

export const Route = createFileRoute("/connect/payments")({
	validateSearch: (search: Record<string, unknown>): PaymentsSearchParams => ({
		provider_id: cleanId(search.provider_id),
	}),
	component: PaymentsPage,
});
